
  import HomeView from "@/views/userportal/subviews/HomeView.vue";
  import NavBar from "@/components/navigation/NavBar.vue"; // @ is an alias to /src  
  import { Options, Vue } from "vue-class-component";
  
    @Options({
        components: {
            HomeView,
            NavBar
        }
    })
    export default class AdminPortal extends Vue {
        activePage = "home-view";

        setActivePage(page: string) { 
            this.activePage = page; 
        }
    }
